import address from '@apis/address';
import auth from '@apis/auth';
import coupon from '@apis/coupon';
import coreConfig from '@apis/core-config';
import log from '@apis/log';
import order from '@apis/order';
import refund from '@apis/refund';
import setting from '@apis/setting';
import store from '@apis/store';
import util from '@apis/util';
import cache from '@apis/cache';

export default {
  auth,
  setting,
  address,
  store,
  order,
  coreConfig,
  util,
  log,
  coupon,
  refund,
  cache,
};
